module.exports = __webpack_public_path__ + "static/media/report-audit.f7f7bf8d.svg";